export enum Civil3dPropertySet {
  ARCGIS_WORKAROUND = 'ArcGIS Workaround',
  SURVEY_LANDXML = 'Survey LandXML',
  SURVEY_USER_DEFINED = 'Survey User-Defined',
  UNCLASSIFIED = 'Unclassified',
  POINT_OBJECT_PROPERTIES = 'Point Object Properties',
  LINE_OBJECT_PROPERTIES = 'Line Object Properties',
}
